import component from '@123/druid/dist/Framework/Decorators/Component';
import View from '@123/druid/dist/Framework/View/View';
import onClick from '@123/druid/dist/Framework/Decorators/OnClick';
import RecommendationPopup from '@Component/Recommendation/RecommendationPopup';
import prop from '@123/druid/dist/Framework/Decorators/Prop';

@component
export default class AlternativeButtonView extends View {
    @prop('number') declare private productId: number;

    @onClick('alternative-button')
    protected async openPopup(): Promise<void> {
        await new RecommendationPopup(this.productId).open();
    }
}
